const STOCK_CHART_COMMAND_PKG = {
    navTitle: "Stock Charts",
    routerName: "StockChartsDocs",
    commandsDescription: "Intraday, Daily, Detailed, etc...",

    commandList: [
        {
            title: "Intraday 3m Chart",
            routerRef: "c3m",
            commandString: "!c3m <Symbol>",
            description: "Gives intraday 3m chart for a stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock you want the 3 minute chart of" },
            ],
            examples: [
                "!c3m GOOGL",
                "!c3m AMD"
            ],
            type: "Stock Charts", 
            shortcuts: ["none"]
        },

        {
            title: "Intraday 5m Chart",
            routerRef: "c5m",
            commandString: "!c5m <Symbol>",
            description: "Gives intraday 5m chart for a stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock you want the 5 minute chart of" },
            ],
            examples: [
                "!c5m GOOGL",
                "!c5m AMD"
            ],
            type: "Stock Charts", 
            shortcuts: ["none"]
        },
        {
            title: "Intraday 15m Chart",
            routerRef: "c15m",
            commandString: "!c15m <Symbol>",
            description: "Gives intraday c15m chart for a stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock you want the 15 minute chart of" },
            ],
            examples: [
                "!c15m GOOGL",
                "!c15m AMD"
            ],
            type: "Stock Charts", 
            shortcuts: ["none"]
        },
        {
            title: "Daily Chart",
            routerRef: "cd",
            commandString: "!cd <Symbol>",
            description: "Gives daily chart for a stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock you want the daily chart of" },
            ],
            examples: [
                "!cd GOOGL",
                "!cd AMD"
            ],
            type: "Stock Charts", 
            shortcuts: ["none"]
        },
        {
            title: "Monthly Chart",
            routerRef: "cm",
            commandString: "!cm <Symbol>",
            description: "Gives the monthly chart for a stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock you want the monthly chart of" },
            ],
            examples: [
                "!cm GOOGL",
                "!cm AMD"
            ],
            type: "Stock Charts", 
            shortcuts: ["none"]
        },
        {
            title: "Weekly Chart",
            routerRef: "cw",
            commandString: "!cw <Symbol>",
            description: "Gives the weekly chart for a stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock you want the weekly chart of" },
            ],
            examples: [
                "!cw GOOGL",
                "!cw AMD"
            ],
            type: "Stock Charts", 
            shortcuts: ["none"]
        },
        {
            title: "Secondary Charting",
            routerRef: "chart2",
            commandString: "!chart2 <Symbol>",
            description: "Gives weekly chart for a stock",
            parameters: [
                { name: "Symbol: ", desc: "Secondary charting source" },
            ],
            examples: [
                "!chart2 GOOGL",
                "!chart2 AMD"
            ],
            type: "Stock Charts", 
            shortcuts: ["none"]
        },
        {
            title: "Detailed Charting",
            routerRef: "chart3",
            commandString: "!chart3 <Symbol> <TimeFrame>",
            description: "15m Delayed charting - !chart3 or !c3 stock day,time    ex - !c3 amd 2,5  - Gives you the 2 day 5 min chart. \n" +
                "- Day can be - 1,2,5,10,15,30,90,180,365,720,1095,1825   \n" +
                "- Time (min) can be - 1,2,3,5,10,13,15,30,60,d",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock you want the weekly chart of" },
                { name: "TimeFrame: ", desc: "The timeframe of the stock you want ex - 1,2 or 10,1 from Day, Time" }
            ],
            examples: [
                "!chart3 GOOGL",
                "!chart3 AMD"
            ],
            type: "Stock Charts", 
            shortcuts: ["none"]
        },
        {
            title: "Another Charting Source",
            routerRef: "chart4",
            commandString: "!chart4 <Symbol>",
            description: "1m charting !ch4 or !chart4 - with 9, 20, 50, 200 day sma",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock you want the weekly chart of" },
            ],
            examples: [
                "!chart4 GOOGL",
                "!chart4 AMD"
            ],
            type: "Stock Charts", 
            shortcuts: ["none"]
        },
        {
            title: "Fib Chart",
            routerRef: "chartfib",
            commandString: "!chartfib <Symbol>",
            description: "Gives daily chart with fib lines drawn on",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!chartfib GOOGL",
                "!chartfib AMD"
            ],
            type: "Stock Charts", 
            shortcuts: ["none"]
        },
        {
            title: "PnF Chart",
            routerRef: "chartpnf",
            commandString: "!chartpnf <Symbol>",
            description: "P&F Charting for stocks",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!chartpnf GOOGL",
                "!chartpnf AMD"
            ],
            type: "Stock Charts", 
            shortcuts: ["none"]
        },
        {
            title: "Short Volume",
            routerRef: "shortvolume",
            commandString: "!shortvolume <Symbol>",
            description: "Graph of 30 day histroy of short volume vs vol",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!shortvolume GOOGL",
                "!shortvolume AMD"
            ],
            type: "Stock Charts", 
            shortcuts: ["none"]
        },
    ]

}

export {STOCK_CHART_COMMAND_PKG};